import * as React from "react";
import {getUserByOptionalId} from "../../store/view/user";
import {Option} from "ts-option";

interface Props {
	title: string,
	userId: Option<string>,
	label?: string,
}

export default class PartnerBrandAssignee extends React.Component<Props, {}> {

	renderAgentNameOrBDP(userId: Option<string>) {
		const user = getUserByOptionalId(userId);
		return user.map(u => u.getDisplayName()).getOrElse("Unassigned");
	}

	render() {
		return (
			<div>
				{this.props.label &&
				<div className="m-form-group_label">{this.props.label}</div>}
				<div className="t-body">{this.props.title}: {this.renderAgentNameOrBDP(this.props.userId)}</div>
			</div>
		)
	}
}